import { render, staticRenderFns } from "./Blackouts.vue?vue&type=template&id=ca5c1ca8&scoped=true&"
import script from "./Blackouts.vue?vue&type=script&lang=js&"
export * from "./Blackouts.vue?vue&type=script&lang=js&"
import style0 from "./Blackouts.vue?vue&type=style&index=0&id=ca5c1ca8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5c1ca8",
  null
  
)

export default component.exports